import React from "react";
import PageShell from "./PageShell";
import SplitLayout from "./SplitLayout";

/**
 * Template E — Wizard (PDR §6.E)
 * ──────────────────────────────
 * Purpose : guide multi-step setup (Launch Wizard · Onboarding).
 * Slots   : header, progress (score + ETA callout),
 *           split { stepList (numbered timeline), stepDetail (opened step) }.
 *
 * StepList helper (WizardStep) is exposed for consumers to render a
 * consistent numbered timeline with done / active / blocked states.
 */
export default function TemplateWizard({
  header, progress, stepList, stepDetail, testId = "tpl-wizard",
}) {
  return (
    <PageShell testId={testId}>
      {header}
      {progress}
      <SplitLayout side={<div className="tpl-steps" data-testid="tpl-steps">{stepList}</div>}>
        {stepDetail}
      </SplitLayout>
    </PageShell>
  );
}

/** Individual step chip inside the vertical timeline. */
export function WizardStep({ n, title, description, status = "todo", active, onClick, testId }) {
  return (
    <button
      type="button"
      className="tpl-step"
      data-status={status}
      data-active={active || undefined}
      onClick={onClick}
      data-testid={testId || `tpl-step-${n}`}
    >
      <span className="tpl-step__num">{n}</span>
      <span>
        <span className="tpl-step__title">{title}</span>
        {description && <span className="tpl-step__desc">{description}</span>}
      </span>
    </button>
  );
}
